// extracted by mini-css-extract-plugin
export default {"sectionContainer":"neighborhood_sectionContainer__YT30J","stats":"neighborhood_stats__n5K2Z","statCol":"neighborhood_statCol__LGGkH"};